import { Box, chakra, Flex, Text } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';

interface Props {
  value: number;
  label: string;
}

const SliderValue: FC<Props> = ({ value, label, ...props }) => {
  const sliderWidth = 192;

  return (
    <Flex
      py="8px"
      alignItems="center"
      justifyContent="space-between"
      {...props}
    >
      <Text mr="10px">{label}</Text>
      <Box
        position="relative"
        w={`${sliderWidth}px`}
        minW={`${sliderWidth}px`}
        borderRadius="4px"
        bgColor={Color.Shade500}
        h="6px"
      >
        <Box
          zIndex={1}
          position="absolute"
          h="6px"
          bgColor={Color.Primary500}
          borderRadius="4px"
          left={0}
          w={`${(value / 10) * sliderWidth}px`}
        />
        <Box
        pos="absolute"
          left={`calc(${(value / 10) * sliderWidth}px - 10px)`}
          top="-7px"
          zIndex={2}
          bgColor="#000"
          w="20px"
          h="20px"
          borderRadius="50%"
        />
      </Box>
    </Flex>
  );
};

export default chakra(SliderValue);
